// @ts-nocheck
// Cross-domain cart handoff receiver (MAIN domain only, module).
// Ported from Powder Valley (assets/pv-ads-cart-receive.js).
//
// When a #graf_cart= payload is present, the ads cart's items are added to the
// main cart and the cart UI is refreshed in place via the Section Rendering API
// (no reload, so the pre-merge page never flashes). The transfer overlay
// (graf-cart-transfer-overlay, keyed on the same hash) masks the merge.
(function () {
  var PREFIX = '#graf_cart=';
  var hash = window.location.hash;
  if (hash.indexOf(PREFIX) !== 0) return;

  var docEl = document.documentElement;
  var reveal = function () { docEl.removeAttribute('data-graf-cart-transfer'); };

  var cleanUrl = window.location.pathname + window.location.search;
  history.replaceState(null, '', cleanUrl);

  var parsed;
  try {
    parsed = JSON.parse(decodeURIComponent(hash.slice(PREFIX.length)));
  } catch (e) {
    reveal();
    return;
  }

  var items;
  var openDrawer = false;
  if (Array.isArray(parsed)) {
    items = parsed;
  } else if (parsed && Array.isArray(parsed.items)) {
    items = parsed.items;
    openDrawer = !!parsed.drawer;
  }
  if (!items || !items.length) {
    reveal();
    return;
  }

  var sectionIds = {};
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
    sectionIds[el.dataset.sectionId] = true;
  });
  document.querySelectorAll('cart-icon').forEach(function (icon) {
    var section = icon.closest('.shopify-section');
    if (section && section.id) sectionIds[section.id.replace(/^shopify-section-/, '')] = true;
  });
  var ids = Object.keys(sectionIds);

  var openDrawerThenReveal = function () {
    var tries = 0;
    (function poll() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        reveal();
        drawer.open();
        return;
      }
      if (tries++ < 40) setTimeout(poll, 100);
      else reveal();
    })();
  };

  (async function () {
    try {
      var body = { items: items };
      if (ids.length) body.sections = ids.join(',');

      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await response.json();

      if (data && data.sections) {
        var renderer = await import('@theme/section-renderer');
        for (var id in data.sections) {
          if (data.sections[id]) {
            try { await renderer.morphSection(id, data.sections[id]); } catch (e) {}
          }
        }
      }
    } catch (e) {
      // Fall through to reveal — a failed merge must not leave the spinner stuck.
    } finally {
      if (openDrawer) openDrawerThenReveal();
      else reveal();
    }
  })();
})();
